import styled, { css, keyframes } from 'styled-components';

const nudge = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
`;

export const Hint = styled.button(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.sz.s1};
    align-self: center;
    padding: ${theme.sz.s2} ${theme.sz.s4};
    border: 0;
    background: none;
    color: ${theme.co.neutral99};
    font-size: ${theme.sz.s3};
    cursor: pointer;

    svg {
      width: ${theme.sz.s4};
      height: ${theme.sz.s4};
      animation: ${nudge} 1.6s ease-in-out infinite;

      @media (prefers-reduced-motion: reduce) {
        animation: none;
      }
    }

    ${theme.focusVisible};
  `,
);
